module.exports = __webpack_public_path__ + "05_medium_black.6ef87b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_medium_black.png
// module id = RGrA
// module chunks = 0